import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "@/lib/content";
import { useBooking } from "./BookingContext";
import { usePrices, money } from "./usePrices";

const ServiceRow = ({ s, i, prices }) => {
  const { openBooking } = useBooking();
  const flip = i % 2 === 1;
  return (
    <article data-testid={s.testId} className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center py-16 sm:py-20 border-t border-[#E6E0D4]">
      <Reveal className={`lg:col-span-6 ${flip ? "lg:order-2" : ""}`}>
        <div className="group relative aspect-[5/4] overflow-hidden rounded-[28px] clip-frame">
          <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-105" />
          <div className="spotlight" />
          <span className="absolute top-5 left-6 font-display text-7xl sm:text-8xl text-white/90 font-light">{s.no}</span>
        </div>
      </Reveal>
      <div className="lg:col-span-6">
        <Reveal><h3 className="font-display font-light text-5xl sm:text-6xl text-[#2D2A26]">{s.title}</h3></Reveal>
        <Reveal delay={0.15}><p className="mt-6 text-base md:text-lg text-[#5E584F] leading-relaxed max-w-xl">{s.lede}</p></Reveal>
        <Reveal delay={0.2}>
          <ul className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3 max-w-lg">
            {s.points.map((p) => <li key={p} className="flex items-center gap-3 text-sm text-[#2D2A26]"><span className="w-1.5 h-1.5 rounded-full bg-[#7A8B7B]" />{p}</li>)}
          </ul>
        </Reveal>
        <Reveal delay={0.25} className="mt-10 flex flex-wrap items-center gap-6">
          <motion.button whileTap={{ scale: 0.96 }} data-testid={s.btnId} onClick={() => openBooking(s.id)} className="btn-pill bg-[#2D2A26] text-[#FBFBF8] hover:bg-[#A8613C] px-7 py-4 text-sm">
            Book {s.title.replace(/s$/, "").toLowerCase()} <ArrowUpRight size={16} />
          </motion.button>
          <div data-testid={`price-${s.id}`} className="text-sm text-[#5E584F]">
            {s.id === "psychic-reading"
              ? <div className="flex flex-wrap gap-x-6 gap-y-2">{prices.options.map((o) => <span key={o.minutes}>{o.minutes === 60 ? "1 hr" : `${o.minutes} min`} <span className="font-display text-2xl text-[#2D2A26] ml-1">{money(o.price)}</span></span>)}</div>
              : (prices.ritual ? <><span className="font-display text-2xl text-[#2D2A26]">{money(prices.ritual)}</span> USD per moon ritual</> : "")}
          </div>
        </Reveal>
      </div>
    </article>
  );
};

export const Offerings = () => {
  const prices = usePrices();
  return (
    <section id="offerings" className="py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-10">
          <Reveal className="lg:col-span-4"><Overline>Now offering</Overline></Reveal>
          <Reveal delay={0.1} className="lg:col-span-8">
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2D2A26]"><em className="text-[#A8613C]">Readings</em> that illuminate — and <em className="text-[#A8613C]">rituals</em> that align you with the moon.</h2>
          </Reveal>
        </div>
        {SERVICES.map((s, i) => <ServiceRow key={s.id} s={s} i={i} prices={prices} />)}
      </div>
    </section>
  );
};
